import Vue from 'vue';
import { STORE } from '@/core/store/core.store';
import KEYS from '@/values/keys';
import { TEACHER_PORTAL_WIDGETS } from '@/content/pages/teacher-portal/values/teacher-portal.values';
import { COMPONENT_TYPE } from '@/courses/values/courses.values'
import { COURSE_EVENTS } from '@/content/values/events';
import { COURSES_EVENTS } from '@/courses/values/courses-events.values';
import { MeetingService } from '@/services/meeting.service';
import i18n from '../../../content/lang/content.i18n';
import EdMeetingModal from '@/components/common/ed-meeting-modal/ed-meeting-modal.vue';
import EdCourseContentSidebar from '@/courses/components/ed-course-content-sidebar/ed-course-content-sidebar.vue';
import EdObjectPreview from '@/content/pages/create-lesson/routes/ed-object-preview/ed-object-preview.vue';
import EdLessonCreator from '@/content/pages/create-lesson/routes/ed-lesson-creator/ed-lesson-creator.vue';
import EdSectionMaterialCreator from '@/content/pages/create-lesson/routes/ed-section-material-creator/ed-section-material-creator.vue';
import { SectionsProvider } from '@/content/providers/sections.provider';
import { _APP_STORE } from '@/core/values/app.values';
import {HOMEWORKS_EVENTS} from '@/homework/values/homeworks.values';
import EdHomeworkTeacherSectionPersonCourseViewer
  from '@/homework/component/ed-homework-teacher-section-person-course-viewer/ed-homework-teacher-section-person-course-viewer.vue';
import { Status } from '@/models/status.model';
import { PREFERENCES_STORE } from '@/preferences/values/preferences.values';
import { SCHOOL_CALENDAR_STORE } from '@/tools/store/school-calendar.store';
import { COURSE_MODE } from '@/courses/enums/course-edition.enum';
import EdProjectCreator from '@/content/pages/create-lesson/routes/ed-project-creator/ed-project-creator.vue';
import { SectionSchooolCalendarProvider } from '@/sections/providers/section-school-calendar.provider';
import EdDeckLibraryCreator from '@/courses/components/flash-cards/ed-deck-library-creator/ed-deck-library-creator.vue';
import EdDeckViewerContainer from '@/courses/components/flash-cards/ed-deck-viewer-container/ed-deck-viewer-container.component.vue';
import { SECTION_OPTIONS_ROOT_TEMPLATES, SECTION_TYPES, SECTION_OPTIONS_CONTENT } from '@/content/values/sections';
import { EdContextMenuOptionsModel } from '@/plugins/ed-context-menu/ed-context-menu.plugin';
import { ICreateObjectParans } from '@/courses/interfaces/course-tools.interface';
import { getElementViewportSize } from '@/utils/dom-utils';

export default Vue.component('ed-homeworks-course-container', {
  name: 'ed-homeworks-course-container',
  props: {
    title: String,
    course: Object,
    showEditButton: {
      type: Boolean,
      default: true
    },
    showShowButton: {
      type: Boolean,
      default: true
    },
    presentationModeTeacher: {
      type: Boolean,
      default: false
    }
  },
  components: {
    EdCourseContentSidebar,
    EdObjectPreview,
    EdLessonCreator,
    EdSectionMaterialCreator,
    EdHomeworkTeacherSectionPersonCourseViewer,
    EdProjectCreator,
    EdContentSectionControls: () => import(/* EdContetnSectionControls */'@/courses/components/ed-content-section-controls/ed-content-section-controls.component.vue'),
    EdDeckLibraryCreator,
    EdDeckViewerContainer,
  },
  data: () => {
    return {
      mode: COURSE_MODE.VIEWER,
      showScrollBar : true,
      isLoading: false,
      status: new Status(),
      paramsLessonResume:{
        showHeader: false,
      },
      homeworksSideBar: true,
      currentFolder: {
        materialSelected: null,
        sectionSelected: null ,
        listIds: []
      },
      resizeSidebar: null,
      resizerSidebarDiv: null,
      prevSidebarX: null,
      contentWidth: null,
      randomValue: Math.round(Math.random()*10000),
      resizingSidebar: false
    }
  },
  computed:{
    editionMode(): boolean {
      return this.mode == COURSE_MODE.EDIT;
    },
    loadingCContent(): string{
      return `${this.$i18n.t('common.loading')} ${this.$i18n.t('common.content')}`;
    },
    toggleIconData(): any {
      let isHomeworks = TEACHER_PORTAL_WIDGETS.HOMEWORKS_AND_COURSES.code === this.$store.state.TeacherPortalStore.widgetFullScreen;
      return {
        icon: isHomeworks ? 'minimize-content' : 'expand-line',
        label: isHomeworks ? this.$i18n.t('common.minimize') : this.$i18n.t('common.fullScreen'),
        key: isHomeworks ? null : TEACHER_PORTAL_WIDGETS.HOMEWORKS_AND_COURSES.code
      }
    },
    courseViewerClass(): any {
      return {
        'courseViewerMax' : !this.homeworksSideBar,
        'edg-shimmer-container': this.isLoading,
        'ed-homeworks-course-container__info--loading': this.isLoading
      }
    },
    viewer(): any {
      switch(this.course.component.name) {
        case COMPONENT_TYPE.OBJECT_PREVIEW.code:
          return COMPONENT_TYPE.OBJECT_PREVIEW.viewer;
        case COMPONENT_TYPE.LESSON_CREATOR.code:
          return COMPONENT_TYPE.LESSON_CREATOR.viewer;
        case COMPONENT_TYPE.LESSON_MATERIAL_CREATOR.code:
          return COMPONENT_TYPE.LESSON_MATERIAL_CREATOR.viewer;
        case COMPONENT_TYPE.PROJECT_CREATOR.code:
          return COMPONENT_TYPE.PROJECT_CREATOR.viewer;
        case COMPONENT_TYPE.DECK_CREATOR.code:
          return COMPONENT_TYPE.DECK_CREATOR.viewer;
        case COMPONENT_TYPE.DECK_VIEWER.code:
          return COMPONENT_TYPE.DECK_VIEWER.viewer;
        case COMPONENT_TYPE.HOMEWORK_TEACHER_SECTION_PERSON_COURSE_VIEWER.code:
          return COMPONENT_TYPE.HOMEWORK_TEACHER_SECTION_PERSON_COURSE_VIEWER.viewer;
        default:
          return null;
      }
    },
    isPresentationTeacherMode(): boolean {
      return this.$store.state.CourseStore.isPresentationTeacherMode;
    },
    showSectionPersonCourseViewer(): boolean {
      return this.$store.state.CourseStore.showSectionPersonCourseViewer;
    },
    isStudent() {
      if(this.presentationModeTeacher)
        return this.$store.state.AuthStore.role == KEYS.ROLES.BUYER
      else 
        return this.$store.state.AuthStore.role == KEYS.ROLES.BUYER || (this.$store.getters['AuthStore/isSubstituteTeacher'] && !this.$store.state.ClassesStore.substituteTeacherCanEditClass.get(this.course.classId));
    },
    menuAddOptions() {
      if(this.isTemplateContent) {
        return SectionsProvider.getCreateObjMenu([...SECTION_OPTIONS_ROOT_TEMPLATES], this.$i18n);
      }

      return SectionsProvider.getCreateObjMenu([...SECTION_OPTIONS_CONTENT], this.$i18n);
    }
  },
  methods: {
    onControlsModeChanged(mode) {
      this.mode = mode;
      const isEditionMode = mode === COURSE_MODE.EDIT;
      if(!isEditionMode) {
        this.sendTeacherPosition();
        setTimeout(() => { this.setFoldersState(); },0);
      } else {
        this.$store.dispatch(_APP_STORE.ACTIONS.CLEAN_TEACHER_POSITION);
      }
    },
    sendTeacherPosition() {
      let secId = this.course.viewer.sectionSelected ? this.course.viewer.sectionSelected.id : null;
      let matId = this.course.viewer.materialSelected ? this.course.viewer.materialSelected.relatedContentId : null;
      let sectionId = secId ? secId : matId ? matId : 0;
      this.$store.dispatch(_APP_STORE.ACTIONS.SEND_TEACHER_POSITION, {
        sectionId,
        isFolder: false,
        classId: this.course.classId,
        courseId: this.course.id,
      });
      let currentState: boolean = this.editionMode;
      // this.editionMode = !this.editionMode;
      if(!currentState) return;
      if(this.course.component.name != COMPONENT_TYPE.OBJECT_PREVIEW.code) {
        let selectInfo = { courseId:this.course.id , classId:this.course.classId ,
          componentInfo: { name: null , section: null , edition: false }};
        this.$Courses.Store.setComponentSelected(selectInfo);
      }
      setTimeout(() => {
        this.setFoldersState()
      },0);
    },
    toggleFullScreen(value: string) {
      this.$store.commit(STORE.TEACHER_PORTAL.ACTIONS.SET_WIDGET_FULLSCREEN, value);
      setTimeout(() => { this.$edEventBus.$emit(COURSES_EVENTS.COURSE_WIDGET_RESIZED); }, 400);
    },
    onToggleSidebar() {
      this.contentWidth = null
      this.homeworksSideBar = !this.homeworksSideBar;
    },
    goToMeeting(){
      this.$refs.EdLoading.show();
      MeetingService.joinMeeting(this.course.meetingId).then(res => {
        this.$EdModal.createModal(EdMeetingModal, res);
      }).catch(() => {
        this.$EdModal.createMessageModal({
          title: i18n.t('meetings.homeMeetings.errorCreatingMeetingTitle'),
          body: i18n.t('meetings.homeMeetings.errorEnteringMeetingBody'),
          type: KEYS.EVENT_TYPES.DANGER
        });
      }).finally(() => {
        this.$refs.EdLoading.hide();
      });
    },
    refreshCourses({ courseId , classId}) {
      let doRefresh = classId ?
      courseId == this.course.id && classId == this.course.classId : courseId == this.course.id;
      if(doRefresh) {
        this.isLoading = true;
        this.status.setLoading();
        this.loadCourseContent(courseId);
      }
    },
    async loadCourseContent(courseId) {
      try {
        if(this.isStudent) {
          await this.$store.dispatch(
            PREFERENCES_STORE.ACTIONS.GET_ORGANIZATION_PREFERENCES,
            this.course.organizationId
          );
          await this.$store.dispatch(PREFERENCES_STORE.ACTIONS.GET_USER_CONTENT_PREFERENCES, {
            classId: this.course.classId,
            contentId: courseId,
            userId: this.$store.state.AuthStore.user.id
          });
          await this.$store.dispatch(
            SCHOOL_CALENDAR_STORE.ACTIONS.GET_ORGANIZATION_SCHOOL_DAYS_LIST,
            this.course.organizationId
          );
        }
        await this.$store.dispatch(PREFERENCES_STORE.ACTIONS.GET_CLASS_CONTENT_PREFERENCES, {
          classId: this.course.classId,
          contentId: courseId
        });
        if(this.isStudent) {
          await this.$Courses.Store.getContentForCourseA({
            courseId, classId: this.course.classId
          });
          this.$Courses.Store.getGradingDetailsForCourseA({
            courseId,
            classId: this.course.classId
          });
        } else {
          await this.$Courses.Store.getContentByEditorA({
            courseId, classId: this.course.classId
          });
          this.setSchoolCalendar();
        }
        this.$edEventBus.$emit(COURSES_EVENTS.RElOAD_TYPE_OBJECT_EDITORS);
        this.status.setLoad();
          this.isLoading = false;
      } finally {
        this.status.setLoad();
        this.isLoading = false;
      }
    },
    setSchoolCalendar() {
      if (this.course.schoolCalendar) {
        SectionSchooolCalendarProvider.schoolDays = this.course.schoolCalendar;
        SectionSchooolCalendarProvider.preferences = this.$store.state.SchoolCalendarStore.preferences;
        SectionSchooolCalendarProvider.holidays = this.$store.state.SchoolCalendarStore.holidays;
      }
    },
    createSection() {
      this.$refs.createSection.goToCreateSection()
    },
    refreshTasks(courseId: number) {
      this.$emit('refreshTasks', courseId);
    },
    setFoldersState() {
      if(this.course.component.name !== COMPONENT_TYPE.OBJECT_PREVIEW.code) {
        this.$edEventBus.$emit(COURSES_EVENTS.SECTION_SELECTED, {
          sectionId: -1,
          courseId: this.course.id,
          classId: this.course.classId
        });
        this.$edEventBus.$emit(COURSES_EVENTS.SECTION_OPENED, {
          sectionId: null,
          opened: false,
          courseId: this.course.id,
          classId: this.course.classId
        });
        return;
      }
      this.keepOpenFolders();
    },
    keepOpenFolders() {
      this.currentFolder.listIds = [];
      let selectData = {
        sectionId: null,
        courseId: this.course.id,
        classId: this.course.classId
      }
      if(this.course.viewer.materialSelected) {
        this.currentFolder.materialSelected = true;
        this.currentFolder.sectionSelected = false;
        let parentId: number = this.course.viewer.materialSelected.sectionParentId;
        this.getMaterialIdsToKeepOpen(parentId);
        this.$edEventBus.$emit(COURSE_EVENTS.SECTION_MATERIAL_SELECTED,
        {...selectData , sectionId: parentId});
      } else {
        this.currentFolder.materialSelected = false;
        this.currentFolder.sectionSelected = true;
        let parentId: number = this.course.viewer.sectionSelected.parentId;
        this.getSectionIdsToKeepOpen(parentId);
        this.$edEventBus.$emit(COURSES_EVENTS.SECTION_SELECTED,
        {...selectData , sectionId: parentId});
      }
      this.$edEventBus.$emit(COURSES_EVENTS.KEEP_OPEN_FOLDERS, this.currentFolder);
    },
    getMaterialIdsToKeepOpen(parentId: number) {
      let sectionId: number = parentId;
      if(sectionId) {
        this.currentFolder.listIds.push(sectionId);
        sectionId = SectionsProvider.getSectionMaterialFromId(this.course.materials.nodes, sectionId).parentId;
        sectionId ? this.getMaterialIdsToKeepOpen(sectionId) : null;
      }
    },
    getSectionIdsToKeepOpen(parentId: number) {
      let sectionId: number = parentId;
      if(sectionId) {
        this.currentFolder.listIds.push(sectionId);
        sectionId = SectionsProvider.getSectionByID(this.course.sections, sectionId).parentId;
        sectionId ? this.getSectionIdsToKeepOpen(sectionId) : null;
      }
    },
    resizePage({width, height} : {width: number, height: number}) : void {
      const resizedElement = this.$refs.courseContainerComponent;
      const resizedElementViewport = getElementViewportSize(resizedElement);

      if(this.isLoading){
        return;
      }
      this.$edEventBus.$emit(COURSE_EVENTS.CHANGE_RESIZE, {
        width: resizedElementViewport.width,
        height: resizedElementViewport.height,
        homeworksSideBar: this.homeworksSideBar
      });
      if(!this.resizerSidebarDiv && !this.isPresentationTeacherMode) {
        this.resizerSidebarDiv = document.getElementById(`${this.course.id}${this.randomValue}`)
        this.resizerSidebarDiv.addEventListener('mousedown', this.mousedownResizeSidebar, false)
      }
    },
    mousedownResizeSidebar(e) {
      this.resizingSidebar = true
      this.resizeSidebar = document.getElementById(`${this.course.title}${this.randomValue}`)
      this.resizeSidebar.classList.remove('transition');
      this.prevX = e.clientX;
      document.addEventListener('mousemove', this.mousemoveResizeSidebar, false)
      document.addEventListener('mouseup', this.mouseupResizeSidebar, false)
    },
    mousemoveResizeSidebar(e){
      const rect = this.resizeSidebar.getBoundingClientRect();
      let widthContainer = rect.width - (this.prevX - e.clientX)
      this.resizeSidebar.style.width = (100 * widthContainer / this.resizeSidebar.parentElement.clientWidth) + '%'
      this.prevX = e.clientX
      let widthObject = Math.round((100 * (this.resizeSidebar.clientWidth + 3) / this.resizeSidebar.parentElement.clientWidth) *10 ) / 10
      this.contentWidth = 100 - widthObject;
    },
    mouseupResizeSidebar() {
      document.removeEventListener('mousemove', this.mousemoveResizeSidebar)
      document.removeEventListener('mouseup', this.mouseupResizeSidebar)
      this.resizeSidebar.classList.add('transition');
      this.resizingSidebar = false
    },
    selectAddOption(optionSelected = new EdContextMenuOptionsModel({})) {
      this.goToCreateObject({
        code: optionSelected.code,
        parentId: -1,
        contentId: this.course.id,
        classId: this.course.classId,
        minDate: null,
        contentType: 'SUBJECT',
      });
    },
    goToCreateObject(data: ICreateObjectParans) {
      this.$EdModal.createModal(
        SECTION_TYPES[data.code].modal, { 
          parentId: data.parentId,
          courseId: data.contentId,
          preload: data.preload,
          classId: data.classId,
          minDate: data.minDate,
          contentType: data.contentType || 'SUBJECT',
        }
      );
    }
  },
  created() {
    this.refreshCourses({ courseId: this.course.id });
    this.$edEventBus.$on(COURSES_EVENTS.REFRESH_WIDGET_COURSE, this.refreshCourses);
    this.$edEventBus.$on(HOMEWORKS_EVENTS.WHITEBOARD_CLOSED_ON_DELETE, this.refreshCourses);
  },
  beforeDestroy(){
    this.$edEventBus.$off(COURSES_EVENTS.REFRESH_WIDGET_COURSE, this.refreshCourses);
    this.$edEventBus.$off(HOMEWORKS_EVENTS.WHITEBOARD_CLOSED_ON_DELETE, this.refreshCourses);
    this.$Courses.Store.setShowSectionPersonCourseViewer(false);
    if(this.resizerSidebarDiv) {
      this.resizerSidebarDiv.removeEventListener('mousedown', this.mousedownResize)
    }
    this.contentWidth = null
  }
});
